module.exports = __webpack_public_path__ + "static/assets/be56b5c4595d08184733f41777f91d65.svg";